import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgHeart(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 7.20552C11.1304 5.31363 9.2186 4 7 4C3.96243 4 1.5 6.46243 1.5 9.5C1.5 11.3638 2.30211 12.9086 2.70814 13.6293C4.62832 17.0377 7.71703 19.3815 11.1113 21.1906C11.6669 21.4867 12.3331 21.4867 12.8887 21.1906C16.283 19.3815 19.3717 17.0377 21.2919 13.6293C21.6979 12.9086 22.5 11.3638 22.5 9.5C22.5 6.46243 20.0376 4 17 4C14.7814 4 12.8696 5.31363 12 7.20552Z", fill: "currentColor" })));
}
export default SvgHeart;
